import {COMPANIES_LOAD_SUCCESS} from "../config/actions";

let defaultState = {
    companies: []
};

const companyReducer = (state = defaultState, action) => {
    switch (action.type) {
        case COMPANIES_LOAD_SUCCESS:
            return {
                ...state,
                companies: action.companies
            };
        default:
            return state;
    }
};

export default companyReducer;
